import React from "react";

const ContentList = ({ contents, contentType, archivedCallback, isAdmin, showContentStatus }) => {
  return (
    <div>
      {contents.data &&
        contents.data.length > 0 &&
        contents.data.map((item) => {
          const isArchived = item.content_status?.id === 3;

          return (
            <div key={item.id}>
              <div className="w-full flex content-center py-7 hover:bg-gray-50">
                <div
                  className={`w-[75%] block content-center pl-5 ${
                    isArchived ? "text-gray-400" : "text-black"
                  }`}
                >
                  <div className="flex pb-2 items-center">
                    <div className="text-md font-semibold content-center">
                      {item.title}
                    </div>
                   {showContentStatus && (
                   <div
                      className={
                        "text-[10px] ml-2 content-center border px-3 rounded-md font-medium " +
                        (item.content_status.name === "Draft"
                          ? "bg-yellow-100 border-yellow-300 text-yellow-600"
                          : item.content_status.name === "Published"
                          ? "bg-green-100 border-green-300 text-green-600"
                          : "bg-gray-200 border-gray-300 text-gray-500")
                      }
                    >
                      {item.content_status.name}
                    </div>
                   )}
                  </div>
                  <div className="whitespace-pre">
                    {`${new Date(item.created_at).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "2-digit",
                    })}  •  ${item.author}`}
                  </div>
                </div>
                <div className={`w-[20%] content-center text-center ${isArchived ? "text-gray-400" : "text-black"}`}>
                  {item.topic.name}
                </div>
                {isAdmin && (
                <div className={`${isArchived ? "w-[10%]" : "w-[10%]"} flex justify-center items-center`}>
                  {!isArchived ? (
                    <>
                      <div className="mr-2">
                        <a href={`/ava-admin/${contentType}/update/${item.id}`}>
                          <button className="bg-white text-blue-500 mr-4">Edit</button>
                        </a>
                      </div>
                      <button
                        onClick={() => archivedCallback(item)}
                        className="bg-white text-blue-500"
                      >
                        Archive
                      </button>
                    </>
                  ) : (
                      <button
                        onClick={() => archivedCallback(item)}
                        className="bg-white text-red-500"
                      >
                        Unarchive
                      </button>
                      )}
                    </div>
                  )}
                  </div>
              <div className="h-[1px] bg-gray-300 w-full"></div>
            </div>
          );
        })}
    </div>
  );
};

export default ContentList;
